import React from "react";
import styled from "@emotion/styled";

const PrimaryButton = styled.button`
  border: none;
  background: #c7a878;
  border-radius: 80px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #ffffff;
  height: 56px;
  width: 100%;

  &:focus {
    outline: none;
  }
  &:hover {
    background: #ad9269;
  }
  &[disabled] {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const SecondaryButton = styled.button`
  background: #ffffff;
  border-radius: 80px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #c7a878;
  border: 1px solid rgba(199, 168, 120, 0.32);
  height: 40px;
  width: 100%;

  &:focus {
    outline-color: #c7a878;
  }
  &:hover {
    transform: translateY(-0.5px);
    outline: #c7a878 solid 1px;
  }
`;

export { PrimaryButton, SecondaryButton };
